import { createSession, isAuthenticated } from './AppSession';
// import { login } from './actions/index';

export const SESSION_KEYS = {
    TOKEN: 'TOKEN',
    EXPIRY: 'EXPIRY',
    BASIC_AUTH: 'BASIC_AUTH'
};

export const HEADERS = {

    PUBLIC: () => {
        return {
            'Accept': 'application/json,text/plain',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Access-Control-Allow-Origin': '*'
        }
    },

    LOGIN: (basicData) => {
        return {
            'Accept': 'application/json,text/plain',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Basic ${basicData}`,
            'Access-Control-Allow-Origin': '*'
            
        }
    },
    SECURED: async () => {
        return {
            'Accept': 'application/json,text/plain',
            'Authorization': 'Bearer ' + await token(),
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        };

    }
}

const token = async () => {
    if (isAuthenticated()) {
        const token = localStorage.getItem(SESSION_KEYS.TOKEN);
        return token;
    } 
    // else {
    //     if (localStorage.getItem(SESSION_KEYS.BASIC_AUTH) !== null) {
    //         return await login(localStorage.getItem(SESSION_KEYS.BASIC_AUTH)).then(async data => { await createSession(data.data.data); }).then(e => {
    //             const token = localStorage.getItem(SESSION_KEYS.TOKEN);
    //             return token;
    //         }).catch((error) => {
    //             return false;
    //         })
    //     }else{
    //         return false;
    //     }
    // }
}